<div class="flex flex-col gap-3">
  <div class="text-general-title">
    <div class="text-(--color-text-primary)" mat-dialog-title>
      {{ 'quotation.fieldNames.deleteAccessory' | translate }}
    </div>
  </div>

  <div mat-dialog-content class="text-general text-center">
    {{ 'quotation.fieldNames.deleteAccessoryConfirm' | translate }}
  </div>

  <div mat-dialog-actions class="flex justify-center gap-3">
    <button matButton="filled" class="button-general-light" (click)="closeModal()">
      {{ 'general.cancel' | translate }}
    </button>
    <button matButton="filled" class="button-general-light" (click)="deleteAccessory()">
      {{ 'general.save' | translate }}
    </button>
  </div>
</div>
